import { render } from "./Advanced.vue?vue&type=template&id=5bdc52fd&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"

import "./Advanced.vue?vue&type=style&index=0&id=5bdc52fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdc52fd"]])

export default __exports__